﻿export function setTabComponentOverflowByIdentifier(identifier: string) {
	var tabComponent = document.getElementById(identifier);
	if (tabComponent != null) {
		setTabComponentOverflow(tabComponent);
	}
}

export function setTabComponentOverflow(tabComponent: HTMLElement) {
	if (tabComponent) {
		
		var tabLinkContainer = tabComponent.querySelector('.veva-tabs-tabs');
		if (tabLinkContainer != null) {
			var isOverflowing = tabLinkContainer.clientWidth < tabLinkContainer.scrollWidth;// || tabLinkContainer.clientHeight < tabLinkContainer.scrollHeight;
			
			if (isOverflowing) {
				tabLinkContainer.classList.add('veva-tabs-tabs--overflowing')
			} else {
				tabLinkContainer.classList.remove('veva-tabs-tabs--overflowing')
			}
		}
	}  
}

export function initializeTabComponent(identifier: string) {
	var tabComponent = document.getElementById(identifier);
	
	if (tabComponent) {
		var tabs = tabComponent.querySelectorAll(':scope > .veva-tabs-tabs .veva-tabs-tab');
		var tabPanes = tabComponent.querySelectorAll(':scope > .veva-tabs-panes .veva-tabs-pane');	

		setTabComponentOverflow(tabComponent);

		Array.from(tabs).forEach((elementInArray: Element) => {
			var element = (elementInArray as HTMLElement);
			if (element != null) {
				
				element.addEventListener('click', (e) => {

					Array.from(tabs).forEach((elementInArray: Element) => {
						var tab = (elementInArray as HTMLElement);
						if (element == tab) tab.classList.add('veva-tabs-tab--active');
						else tab.classList.remove('veva-tabs-tab--active');
					});

					Array.from(tabPanes).forEach((element) => {
						element.classList.remove('veva-tabs-pane--show');
					});

					//window.setHash('tab-' + element.dataset.hash);

					var activeTabPane = document.getElementById('veva-tabs-pane-' + element.dataset.hash);
					if (activeTabPane) {
						activeTabPane.classList.add('veva-tabs-pane--show');
					}

					//e.preventDefault();
				});
			}
		});

		var activeTabPane = null;
		var activeTab = null;

		 
		if (document.location.hash && document.location.hash.startsWith('#tab-')) {
			var tabPane = tabComponent.querySelectorAll(':scope > .veva-tabs-panes #veva-tabs-pane-' + document.location.hash.replace('#tab-', ''));			
			if (tabPane.length > 0) activeTabPane = tabPane[0];

		}

		if (!activeTabPane) {
			activeTabPane = tabComponent.querySelectorAll(':scope > .veva-tabs-panes .veva-tabs-pane')[0];
		}

		if (document.location.hash && document.location.hash.startsWith('#tab-')) {
			var tab = tabComponent.querySelectorAll(':scope > .veva-tabs-tabs #veva-tabs-tab-' + document.location.hash.replace('#tab-', ''));

			if (tab.length > 0) {
				activeTab = tab[0]
			}
		}

		if (!activeTab) {
			activeTab = tabComponent.querySelectorAll(':scope > .veva-tabs-tabs .veva-tabs-tab')[0];
		}
		
		if (activeTabPane) {
			activeTabPane.classList.add('veva-tabs-pane--show');
		}

		if (activeTab) {
			activeTab.classList.add('veva-tabs-tab--active');
		}
	}
}

